module.exports = __webpack_public_path__ + "img/ic-jcdw-point.df879be0.png";